// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Formatter from '../../i18n/formatter';
import { __, getCurrency } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { BasketRow } from '../../styled-components/shared';

const PotentialRow = styled(BasketRow)`
  margin: 0.4em 0;
`;

const PotentialLabel = styled.span`
  color: ${theme.BasketCard.potentialWinningsColor};
`;

const PotentialValue = styled.span`
  color: ${theme.BasketCard.potentialWinningsColor};
`;

type BasketCardPotentialContentProps = {
  potentialGain: number;
};

const BasketCardPotentialContent = ({ potentialGain }: BasketCardPotentialContentProps) => {
  return (
    <PotentialRow>
      <PotentialLabel>{__('Potential winnings')}</PotentialLabel>
      <PotentialValue>{Formatter.formatNumber(potentialGain, getCurrency())}</PotentialValue>
    </PotentialRow>
  );
};

export default BasketCardPotentialContent;
